"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Units = [
    'zero',
    'jeden',
    'dwa',
    'trzy',
    'cztery',
    'pięć',
    'sześć',
    'siedem',
    'osiem',
    'dziewięć',
    'dziesięć',
    'jedenaście',
    'dwanaście',
    'trzynaście',
    'czternaście',
    'piętnaście',
    'szesnaście',
    'siedemnaście',
    'osiemnaście',
    'dziewiętnaście'
];
//Tablica opisów dziesiątek
var Tens = ['dwadzieścia', 'trzydzieści', 'czterdzieści', 'pięćdziesiąt', 'sześćdziesiąt', 'siedemdziesiąt', 'osiemdziesiąt', 'dziewięćdziesiąt'];
//Tablica obisów setek
var Hundreds = ['', 'sto', 'dwieście', 'trzysta', 'czterysta', 'pięćset', 'sześćset', 'siedemset', 'osiemset', 'dziewięćset'];
//Dwuwymiarowa tablica tysięcy,milionów,miliarów ...
var OtherUnits = [
    ['tysiąc', 'tysiące', 'tysięcy'],
    ['milion', 'miliony', 'milionów'],
    ['miliard', 'miliardy', 'miliardów'],
    ['bilion', 'biliony', 'bilionów'],
    ['biliard', 'biliardy', 'biliardów'],
    ['trylion', 'tryliony', 'trylionów'],
    ['tryliard', 'tryliardy', 'tryliardów'],
    ['kwadrylion', 'kwadryliony', 'kwadrylionów'],
    ['kwadryliard', 'kwadryliardy', 'kwadryliardów']
];
//Konwersja małych liczb ....
function SmallValueToWords(n) {
    if (n === 0) {
        return null;
    }
    var valueInWords = '';
    // Konwertuj setki.
    var temp = Math.floor(n / 100);
    if (temp > 0) {
        valueInWords += Hundreds[temp];
        n -= temp * 100;
    }
    // Konwertuj dziesiątki i jedności.
    if (n > 0) {
        if (valueInWords.length > 0) {
            valueInWords += ' ';
        }
        if (n < 20) {
            //  Liczby poniżej 20 przekonwertuj na podstawie
            //  tablicy jedności.
            valueInWords += Units[n];
        }
        else {
            //  Większe liczby przekonwertuj łącząc nazwy
            //  krotności dziesiątek z nazwami jedności.
            valueInWords += Tens[Math.floor(n / 10) - 2];
            var lastDigit = n % 10;
            if (lastDigit > 0) {
                valueInWords += ' ';
                valueInWords += Units[lastDigit];
            }
        }
    }
    return valueInWords;
}
//Obliczenia dla dużych liczb ... i odmiana prawidłowa ich wartości..
/// <summary>
/// 2 - D. lm (tysięcy)
/// 1 - M. lm (tysiące)
/// 0 - M. lp (tysiąc)
/// </summary>
/// <param name="n"></param>
/// <returns></returns>
function GetBigUnitIndex(n) {
    var lastDigit = n % 10;
    if (n / 10 >= 1 && lastDigit == 1) {
        return 2;
    }
    var last2digits = n % 100;
    //if ((n >= 10 && (n <= 20 || lastDigit == 0)) || lastDigit > 4) {
    if ((last2digits >= 10 && (last2digits <= 20 || lastDigit == 0)) || lastDigit > 4) {
        return 2;
    }
    return lastDigit == 1 ? 0 : 1;
}
function ToWords2(valueInWords, n, level) {
    var smallValue = 0;
    //long divisor = (long)Math.pow(10000, (long)level + 1);
    var divisor = Math.pow(1000, level + 1);
    var rest = n;
    if (divisor <= n) {
        //  Jeśli liczbę da się podzielić przez najbliższą
        //  potęgę 1000, kontynuuj rekurencję.
        n = ToWords2(valueInWords, n, level + 1);
        var pvalue = n / divisor;
        smallValue = Math.floor(pvalue);
        if (valueInWords.text.length > 0) {
            valueInWords.text += ' ';
        }
        rest = n - smallValue * divisor;
        if (smallValue > 0) {
            //teraz dopisuje jeden, np: jeden tysiąc
            //if (smallValue > 1)
            if (smallValue > 1 || valueInWords.text.length > 0 || rest === 0) {
                //if (true) {
                valueInWords.text += SmallValueToWords(smallValue);
                valueInWords.text += ' ';
            }
        }
        if (smallValue > 0) {
            valueInWords.text += OtherUnits[level][GetBigUnitIndex(smallValue)];
        }
    }
    return rest;
}
function ToWords(value) {
    if (value == 0) {
        // Zero.
        return Units[0];
    }
    var valueInWords = {
        text: ''
    };
    var smallValue = ToWords2(valueInWords, value, 0);
    if (smallValue > 0) {
        if (valueInWords.text.length > 0) {
            valueInWords.text += ' ';
        }
        valueInWords.text += SmallValueToWords(smallValue);
    }
    return valueInWords.text;
}
function liczba_zlotych(kwota) {
    //DecimalFormat dfx =  new DecimalFormat("0");
    return Math.floor(kwota);
    var szlote = '' + (kwota || 0);
    //    dfx.format(kwota);
    var dzlote = parseInt(szlote);
    return dzlote;
}
function liczba_groszy(grosze) {
    //Tworzę format zmiennych aby uzyskać liczbę w frmie tekstowej
    //DecimalFormat dfx =  new DecimalFormat("0.00");
    //String szlote = dfx.format(grosze);
    var tgrosze = grosze;
    var zlote = liczba_zlotych(grosze);
    var result = (tgrosze - zlote) * 100;
    return Math.round(result);
}
/**
 * Zamiana liczny na słownie
 * @param liczba liczba do zamiany na słownie
 */
function slownie(liczba) {
    //Generalna funkcja ptzetworzenia zmiennej
    if (liczba < 0) {
        liczba = liczba * -1;
    }
    return ToWords(Math.floor(liczba));
}
exports.default = slownie;
//# sourceMappingURL=slownie.js.map